import { render } from 'react-dom';

import { ErrorBoundary } from '@components/error-boundary';
import { RouteErrorBoundary } from '@components/route-error-boundary';
import { setSentryContext, startSentry } from '@utils/sentry';

import { App } from './App';
import { config } from './app-config';

import '@styles/variables.css';
import '@styles/reset.css';

if (config.SENTRY_URL) {
  startSentry(config.SENTRY_URL);
  setSentryContext('build', {
    buildDate: process.env.__BUILD_DATE__,
    buildRef: process.env.__BUILD_REF__,
  });
}

render(
  <ErrorBoundary fallback={<RouteErrorBoundary />}>
    <App />
  </ErrorBoundary>,
  document.getElementById('root'),
);

// @ts-ignore-next-line
window.buildDate = config.BUILD_DATE;
// @ts-ignore-next-line
window.buildRef = config.BUILD_REF;
